<!-- ### https://amcnewshandler.amc.info/de/newsletter ### -->
<div class="container">
  <div class="row vertical-align">
    <div class="col-md-8 col-sm-8 col-xs-12">
      <!--      <h1 class="text-headline">{{getFieldLabel("nl_heading")}}</h1>-->
      <h3>Newsletter-Abonnement verwalten</h3>
<!--      <div *ngIf="getFieldLabel('nl_heading_content_1') && getFieldLabel('nl_heading_content_2') &&-->
<!--              getFieldLabel('nl_heading_content_3') && getFieldLabel('nl_heading_content_4') &&-->
<!--              getFieldLabel('nl_heading_content_5') && getFieldLabel('nl_heading_content_6') ">-->
      <div>
      <p>
          Schade, dass du uns verlassen möchtest. Durch die Bestätigung wirst
          du keine weiteren Updates zu unseren Produkten, Aktionen und sonstigen AMC-Neuigkeiten
          erhalten. Du kannst dich auch nur von einzlnen Services abmelden.
        </p>
      </div>
    </div>
    <div class="col-md-4 col-sm-4 hidden-xs">
      <img class="img-responsive nlImg" src="{{cancelImage}}" />
    </div>
  </div>

  <form id="newsletterForm" [formGroup]="amcUnsubForm" (ngSubmit)="onSubmitUnsub()">
    <table class="table table-bordered">
      <thead>
      <tr>
        <th><input type="checkbox" [checked]="isAllChecked()" (change)="checkAllCheckBox($event)"
                   formControlName="all" id="all" name="all" ></th>
        <th>Channel</th>
        <th>Service</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td><input formControlName="email_nl" type="checkbox"  id="email_nl" name="email_nl"></td>
        <td>E-Mail</td>
        <td>
          <p>
            <b>AMC Newsletter: </b>Regelmäßiger AMC-Newsletter mit Produktinformationen, leckeren Rezeptidden, Tipps und Tricks.
          </p>
        </td>
      </tr>
      <tr>
        <td><input formControlName="email_ms" type="checkbox"  id="email_ms" name="email_ms"></td>
        <td>E-Mail</td>
        <td>
          <p>
            <b>AMC Informationen: </b>Allgemeine Informationen und Neuigkeiten von AMC
          </p>
        </td>
      </tr>
      <tr>
        <td><input formControlName="email_is" type="checkbox"  id="email_is" name="email_is"></td>
        <td>E-Mail</td>
        <td>
          <p>
            <b>AMC Specials: </b>Informationen über AMC-Dienstleistungen, Produktneuigkeiten und Promotionen
          </p>
        </td>
      </tr>
      <tr>
        <td><input formControlName="post" type="checkbox"  id="post" name="post"></td>
        <td>Post</td>
        <td>Mail</td>
      </tr>
      <tr>
        <td><input formControlName="phone" type="checkbox"  id="phone" name="phone"></td>
        <td>Telefon</td>
        <td>SMS</td>
      </tr>
      </tbody>
    </table>

    <!--    &lt;!&ndash; Button for for submit &ndash;&gt;-->
    <div class="form-group row">
      <div class="col-md-8 col-sm-8 col-xs-12">
        <button type="submit" id="subButtonAngular" name="subButtonAngular" class="button-rounded">
          <!--          {{getFieldLabel("nl_submit")}}-->
          Bestätigen
        </button>
      </div>
    </div>
  </form>
</div>
